import { render, staticRenderFns } from "./unenrollment.vue?vue&type=template&id=6c5b5144&"
import script from "./unenrollment.vue?vue&type=script&lang=js&"
export * from "./unenrollment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports